import { publicUrls } from "../Api/Auth/AppUrls";

export const seoData = {
  [publicUrls.Home]: {
    title: "RoadtoFE | FE Exam Preparation for Engineering Students",
    description:
      "RoadtoFE provides expert-led courses, realistic practice tests, and high-quality materials for FE exam preparation in civil, mechanical, and other engineering disciplines.",
    keywords: "FE exam preparation",
  },
  [publicUrls.About]: {
    title: "About RoadtoFE | Your Partner in FE Exam Success",
    description:
      "Discover RoadtoFE's mission and commitment to helping engineering students succeed in the FE exam through structured support and expert resources.",
    keywords: "about FE exam prep platform",
  },
  [publicUrls.Contact]: {
    title: "Contact RoadtoFE | Reach Out to Our Support Team",
    description:
      "Have questions or need assistance? Contact RoadtoFE for expert guidance on courses, materials, or FE exam prep strategies.",
    keywords: "contact FE exam support team",
  },
  [publicUrls.NewsArchive]: {
    title: "RoadtoFE News & Insights | FE Exam Tips, Updates, and Strategies",
    description:
      "Stay informed with RoadtoFE's latest news, blog posts, and expert insights on FE exam preparation. Discover tips, updates, success stories, and more.",
    keywords: "FE exam blog, FE exam tips, FE exam news, RoadtoFE articles",
  },

  [publicUrls.LiveOnlineClass]: {
    title: "Live Online FE Exam Classes | Learn from Experts | RoadtoFE",
    description:
      "Join live online FE exam classes with experienced instructors. Get real-time interaction, feedback, and support for all major engineering disciplines.",
    keywords: "live FE exam classes",
  },
  [publicUrls.Tutorial]: {
    title: "FE Exam Tutorials | Concept-Focused Learning | RoadtoFE",
    description:
      "Strengthen your fundamentals with structured FE exam tutorials. A focused approach to mastering essential engineering concepts.",
    keywords: "FE exam tutorial sessions",
  },
  [publicUrls.SelfStudy]: {
    title: "Self-Paced FE Exam Prep | Study Anytime, Anywhere | RoadtoFE",
    description:
      "Prepare at your convenience with RoadtoFE's self-study FE exam resources. Access expert-developed materials whenever you need.",
    keywords: "self study FE exam course",
  },
  [publicUrls.CivilCourses]: {
    title: "RoadtoFE Courses | FE Exam Prep for Civil & Mechanical Engineering",
    description:
      "Browse RoadtoFE's comprehensive FE exam prep courses tailored for civil and mechanical engineering disciplines. Designed for effective NCEES preparation.",
    keywords: "FE exam prep courses",
  },
  [publicUrls.MechanicalCourses]: {
    title: "RoadtoFE Courses | FE Exam Prep for Civil & Mechanical Engineering",
    description:
      "Browse RoadtoFE's comprehensive FE exam prep courses tailored for civil and mechanical engineering disciplines. Designed for effective NCEES preparation.",
    keywords: "FE exam prep courses",
  },
  //civil
  [publicUrls.LiveClassCivil]: {
    title: "Live Online FE Civil Engineering Classes | RoadtoFE",
    description:
      "Attend live FE civil engineering classes taught by seasoned instructors. Real-time learning and personalized guidance for NCEES success.",
    keywords: "live FE exam classes for civil engineering",
  },

  [publicUrls.FreeFeTestCivil]: {
    title: "Free FE Civil Model Test Practice | RoadtoFE",
    description:
      "Simulate the real FE exam experience with our free civil engineering model test. Get instant scoring and performance feedback.",
    keywords: "free FE civil engineering model test",
  },

  [publicUrls.FreeFeMaterialsCivil]: {
    title: "Download Free FE Civil Engineering Study Materials | RoadtoFE",
    description:
      "Access expertly crafted free FE civil materials to kickstart your preparation. Trusted resources aligned with NCEES guidelines.",
    keywords: "free FE civil exam study materials",
  },

  [publicUrls.PaidModelTestCivil]: {
    title: "Premium FE Civil Practice Tests | RoadtoFE",
    description:
      "Take full-length, exam-style practice tests for the FE civil exam. Get detailed solutions and performance analytics.",
    keywords: "paid FE civil engineering practice test",
  },

  [publicUrls.tutoringCivil]: {
    title: "One-on-One Civil Engineering FE Exam Tutoring | RoadtoFE",
    description:
      "Benefit from personalized FE civil tutoring with expert mentors. Learn at your own pace with sessions tailored to your needs.",
    keywords: "FE civil engineering personal tutoring",
  },

  [publicUrls.feSubscriptionCivil]: {
    title: "FE Civil Exam Material Subscription | Full Access | RoadtoFE",
    description:
      "Subscribe for complete access to up-to-date FE civil engineering content. Streamline your prep with structured learning modules.",
    keywords: "FE civil engineering exam subscription",
  },

  [publicUrls.practiceHubCivil]: {
    title: "FE Civil Engineering Practice Hub | RoadtoFE",
    description:
      "Improve steadily with topic-wise FE civil practice questions. Monitor your progress and focus on areas that need improvement.",
    keywords: "FE civil engineering practice questions",
  },
};
